<template>
  <div class="updatePass-container">
    <div class="box">
      <div class="banner">
        <img src="../../assets/banner.png">
      </div>
      <div class="title">
        <h3>Change password </h3>
        <span @click="$router.go(-1)">back</span>
      </div>
      <div class="cardList">
        <van-form @submit="onSubmit" ref="msgForm">
        <van-field
          v-model="msg.oldPwd"
          name="old password"
          label="old password"
          placeholder="please enter the old password"
          :rules="msgFormRules.oldPwd"
          type="password"
        />
        <van-field
          v-model="msg.newPwd"
          name="new password"
          label="new password"
          placeholder="please enter the new password"
          :rules="msgFormRules.newPwd"
          type="password"
        />
        <van-field
          v-model="msg.confirmPwd"
          name="confirm the password"
          label="confirm the password"
          placeholder="please enter the confirmation password"
          :rules="msgFormRules.confirmPwd"
          type="password"
        />
        <div class="submitBox">
          <van-button round block type="info" :loading='btnLoading' native-type="submit">
            submit
          </van-button>
        </div>
      </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api'
export default {
  name: 'addCard',
  props: {},
  data () {
    return {
      ExhID: this.$store.state.EXHID,
      btnLoading: false,
      msg: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      msgFormRules: {
        oldPwd: [{
          required: true,
          message: '请输入旧密码'
        }],
        newPwd: [{
          required: true,
          message: '请输入新密码'
        }],
        confirmPwd: [{
          required: true,
          message: '请输入确认密码'
        }]
      }
    }
  },
  computed: {
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
    async onSubmit (values) {
      try {
        await this.$refs.msgForm.validate()
      } catch (err) {
        return
      }
      this.btnLoading = true
      api.updateactorpwd({
        exhId: this.ExhID,
        oldPwd: this.msg.oldPwd,
        newPwd: this.msg.newPwd,
        confirmPwd: this.msg.confirmPwd
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.fail('修改成功！')
          this.$router.push('/exhibitorCardAppli')
        } else if (res.data.code === 900) {
          this.$toast.fail('登录超时！')
          this.$router.push('/')
          this.btnLoading = false
        } else {
          this.$toast.fail(res.data.msg)
          this.btnLoading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.updatePass-container{
  .box {
      width: 100%;
      margin: 0 auto;
  }
  .banner {
      width: 100%;
      margin: 0 auto;
      box-shadow: 0px 5px 10px 0px #f4f4f4;
  }
  .banner > img {
      width: 100%;
      margin: 0 auto;
  }
  .title{
    display: flex;
    justify-content: space-between;
    background: #f0f0f0;
    margin-top: 1rem;
    align-items: center;
    padding:0 0.3rem;
    h3{
      font-size: 0.52rem;
      padding: 0.3rem 0;
      font-weight: bold;
    }
    span{
      color:#1C80CC
    }
  }
  .cardList{
    width: 100%;
    margin-bottom: 50px;
  }
  .van-form{
    padding: 0.6rem;
  }
  .van-form{
    padding:0.6rem;
    .van-cell{
      font-size:0.43rem;
      padding:0.3rem 0;
      border-bottom: 1px solid #ccc;
      margin-bottom: 0.33rem;
    }
  }
  .van-field__label{
    color:#969696;
  }
  .van-field__control{
    text-align: right;
  }
  .van-field::before{
    content: '*';
    color:red;
    padding-right: 0.1rem;
  }
  .submitBox{
    padding:1rem 0;
  }
}
</style>
